import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { SuperSentInvoiceListItem } from '@models';
import { IApiRequest, IApiResponse } from '../../interfaces';

export const SentInvoicesActions = createActionGroup({
  source: 'SentInvoices',
  events: {
    load: emptyProps(),
    loaded: props<{ response: IApiResponse<SuperSentInvoiceListItem[]> }>(),
    loadError: props<{ error: any }>(),
    lastApiRequest: props<{ apiRequest: IApiRequest }>(),
  },
});
